import React from "react";
import HouseDestop from "../assest/house-desktop6.png";
import Couple1 from "../assest/couple1.png";
import Couple2 from "../assest/couple2.png";
import Purple from "../assest/purple.png";
import Footer from "./footer";
const videos = [
  { img: `${Couple1}` },
  { img: `${Couple2}` },
  {},
  {},
  {},
  {},
  {},
  {},
];

const HappyCustomers = () => {
  return (
    <div>
      {/* HERO SECTION */}
      <section
        className="w-full h-[300px] lg:h-[350px] md:h-[260px] bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${HouseDestop})` }}
      ></section>

      {/* CUSTOMER SECTION */}
      <section className="relative py-[100px] px-5 md:py-[70px] md:px-[15px]">
        {/* BACKGROUND IMAGE */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${Purple})` }}
        ></div>

        {/* CONTENT */}
        <div className="relative max-w-[1100px] mx-auto text-center">
          {/* TITLE */}
          <h2 className="text-[34px] md:text-[34px] font-semibold mb-[10px]">
            Happy Customers
          </h2>

          <p className="text-[20px] text-[#444] mb-[40px]">
            Plinth area + balconies, utilities and covered terraces.
          </p>

          {/* GRID */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-[25px] ">
            {videos.map((item, i) => (
              <div
                key={i}
                className="relative bg-[#e3e3e3] rounded-[10px] overflow-hidden flex items-center justify-center
                           h-[150px] lg:h-[280px] md:h-[250px]"
              >
                {/* IMAGE */}
                {item.img && (
                  <img
                    src={item.img}
                    alt="customer"
                    className="w-full h-full object-cover"
                  />
                )}

                {/* YOUTUBE ICON */}
                <i className="hgi hgi-stroke hgi-youtube absolute text-[70px] text-red-600"></i>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer/>
    </div>
  );
};

export default HappyCustomers;
